import {t} from '@di-shared/features/common/useInferableTranslation';
import React from 'react';

function MyMaintenanceGradeError() {
  return (
    <section className="section section_certification_management">
      <div className="section_container_header">
        <h3 className="title_medium_b">{t('T20225')}</h3>
        <div className="my_grade">
          <span className="my_grade_text">{t('T20067')}</span>
        </div>
      </div>
      <div className="section_container">
        <div className="certification_management_header">
          <strong
            className="certification_management_title"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('T30378')}
          </strong>
        </div>
        <div className="certification_management_content">
          <div className="empty_area">
            <span className="ic ic_caution_32px"></span>
            <span
              className="body_small_r"
              style={{whiteSpace: 'pre-wrap'}}
            >
              {t('T30379')}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MyMaintenanceGradeError;
